import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SparklineTooltipStyleConstantType,
    SparklineMeasuresConstantType,
    SparklineDynamicStyleType,
    SparklineMeasures
} from "./type";
import {
    getSurfaceStyle
} from "../../helpers/theme/elevation";
import {
    getFocusRingStyle
} from "../../helpers/theme/state";
import {
    getCornerStyle
} from "../../helpers/theme/corner";
import {
    webStyle
} from "../../utils";

export const SPARKLINE_SMALL_WIDTH_STEPS = 3;

export const getSparklineMeasures = ({
    shapeConfigs,
    radiuses,
    borders
}: SparklineMeasuresConstantType): SparklineMeasures => {
    const dotRadius = shapeConfigs.chartDotSize / 2;

    return {
        inset: dotRadius + shapeConfigs.chartHaloWidth,
        haloWidth: shapeConfigs.chartHaloWidth,
        barRatio: shapeConfigs.chartBandRatio,
        barMax: shapeConfigs.chartBarMax,
        barRadius: radiuses.chartBar,
        lineWidth: borders.chartLine,
        dotRadius
    };
};

const stylesheet = StyleSheet.create({
    container: {
        overflow: "visible",
        flexShrink: 0,
        ...webStyle({
            outlineStyle: "solid",
            userSelect: "none",
            cursor: "default",
            outlineWidth: 0
        })
    },
    tooltip: {
        alignSelf: "flex-start",
        pointerEvents: "none",
        position: "absolute",
        left: 0,
        top: 0
    },
    live: {
        position: "absolute",
        overflow: "hidden",
        opacity: 0
    },
    svg: {
        position: "absolute",
        start: 0,
        top: 0
    },
    unmeasured: {
        opacity: 0
    }
});

export const getSparklineTooltipStyle = ({
    controlPaddings,
    shapeConfigs,
    shadowAlpha,
    elevations,
    radiuses,
    borders,
    colors,
    spaces
}: SparklineTooltipStyleConstantType): ViewStyle => {
    return {
        ...getSurfaceStyle({
            surface: "popover",
            shadowAlpha,
            elevations,
            borders,
            colors
        }),
        ...getCornerStyle({
            radius: radiuses.xs,
            shapeConfigs
        }),
        paddingHorizontal: controlPaddings.small,
        paddingVertical: spaces.spacingXs
    };
};

export const useStyles = ({
    controlHeights,
    isFocusVisible,
    isInteractive,
    shapeConfigs,
    touchTargets,
    radiuses,
    borders,
    colors,
    step,
    size
}: SparklineDynamicStyleType) => {
    const styles = {
        color: step ? colors.chart.sequential[step] : colors.chart.categorical[1],
        container: {
            ...(size === "small" ? {
                width: controlHeights.small * SPARKLINE_SMALL_WIDTH_STEPS,
                height: touchTargets.fine
            } : {
                height: controlHeights.medium,
                width: "100%"
            }),
            ...(isInteractive ? {
                ...getCornerStyle({
                    radius: radiuses.xs,
                    shapeConfigs
                }),
                ...getFocusRingStyle({
                    isFocusVisible,
                    borders,
                    colors
                })
            } : {})
        } as ViewStyle,
        area: colors.chart.categoricalArea[1],
        live: {
            height: borders.line,
            width: borders.line
        } as ViewStyle,
        muted: colors.chart.muted
    };

    return styles;
};
export default stylesheet;
